import React from 'react';
import MyGallery from "../Gallery/MyGallery";
import './ServicesPage.css';
import {useTranslation} from "react-i18next";

function LightingPage() {
    const { t } = useTranslation();
    const directory= "/images/fotismos/";
    const filenames=[
        'VPR02813_Vasso_Paraschi.webp',
        'VPR02815_Vasso_Paraschi.webp',
        'VPR02868_Vasso_Paraschi.webp',
        'VPR02872_Vasso_Paraschi.webp',
        'VPR03167_Vasso_Paraschi.webp',
        'VPR03175_Vasso_Paraschi.webp',
        'VPR03477_Vasso_Paraschi.webp',
        'VPR03488-Enhanced-NR_Vasso_Paraschi.webp',
        'VPR03576-Enhanced-NR_Vasso_Paraschi.webp',
        'VPR03603-Enhanced-NR_Vasso_Paraschi.webp'
    ];

    return (
        <div className="services-page">
            <h1>{t("Lighting")}</h1>
            <div className="services-info-container">
                <MyGallery directory={directory} filenames={filenames} />
            </div>

        </div>
    );
}

export default LightingPage;
